export default __webpack_public_path__ + "static/media/kubernetes.517c3cb0.png";